import React from 'react';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDBodyText, FDHeadlineText, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const sectionMetaOverrideSet = buildBaseOverrides()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md', align: 'center' },
  }, overrideReadOnly);

const InvestmentApproachSection = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDPaper maxWidth={'375px'} padding={4}>
      <FDStack direction={'column'} alignItems={'center'} spacing={1}>
        <FDStack direction={'column'} alignItems={'center'} spacing={2}>
          <FDIcon size={'lg'} icon={resource.attr('iconType')} />
          <MetaControlField attr={'title'} />
        </FDStack>
        <MetaControlField attr={'subtitle'} />
      </FDStack>
    </FDPaper>
  );
};

InvestmentApproachSection.propTypes = {};

InvestmentApproachSection.defaultProps = {};

export default InvestmentApproachSection;
